export const CANONICAL_THREAD_TITLE_MAX_LENGTH = 200;

const RESERVED_THREAD_TITLES = new Set([
  'group thread',
  'new thread',
  'nuevo hilo',
]);

/**
 * Accept only bounded human-facing titles. Known identifiers and Firebase-style
 * opaque ids are metadata, never display labels.
 */
export function normalizeCanonicalThreadTitle(
  raw: unknown,
  knownIds: readonly unknown[] = [],
): string | undefined {
  const value = typeof raw === 'string'
    ? raw.trim().slice(0, CANONICAL_THREAD_TITLE_MAX_LENGTH)
    : '';
  if (!value || RESERVED_THREAD_TITLES.has(value.toLowerCase())) {
    return undefined;
  }

  const ids = new Set(
    knownIds
      .map((id) => String(id ?? '').trim())
      .filter(Boolean),
  );
  return ids.has(value) ? undefined : value;
}
